import { EXAM_COURSE_ROUTES } from "./examCourseRoutes";
import React from "react";
import { Row, Col } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import HomeDashboardLayout from "../HomeDashboardLayout";
import MyWalletSidebar from "../MyWalletSidebar";
import "../../dashboard/Dashboard.css";
import "../HomeDashboard.css";
import "../questionBank/QuestionBankList.css";
import "../DashboardFavoriteExam.css";
import "../DashboardSkeleton.css";
import HeaderProfileSection from "../HeaderProfileSection";
import SliderCard from "../../dashboard/SliderCard";
import LogoIcon from "../../assets/images/SliderLogo.png";
import examFallbackImage from "../../assets/images/state-img.png";
import starIcon from "../../assets/images/bookmark.png";
import { useAuth } from "../../context/AuthContext";
import { useMasterExamCategories } from "../../hooks/useMasterExamCategories";
import "./ExamCourseWalletLayout.css";

function mapMasterExam(exam) {
  return {
    id: Number(exam?.md_exams_id || 0),
    name: exam?.exam_name || "Master exam",
    location: exam?.state_name || "",
    image: exam?.exam_image || examFallbackImage,
    icon: LogoIcon,
    staricon: starIcon,
    isStarred: Number(exam?.is_favourite) === 1,
    isSelected: Number(exam?.is_user_exam) === 1 || Number(exam?.is_subscribed) === 1,
  };
}

function MasterExamShimmer() {
  return (
    <div className="favorite-exam-shimmer" aria-label="Loading master exams">
      {Array.from({ length: 2 }).map((_, sectionIndex) => (
        <section className="favorite-exam-shimmer__section" key={sectionIndex}>
          <span className="favorite-exam-shimmer__heading dashboard-skeleton" />
          <div className="favorite-exam-shimmer__cards favorite-exam-shimmer__cards--exams">
            {Array.from({ length: 4 }).map((__, cardIndex) => (
              <div className="favorite-exam-shimmer__exam dashboard-skeleton" key={cardIndex}>
                <span className="favorite-exam-shimmer__badge dashboard-skeleton" />
                <span className="favorite-exam-shimmer__title dashboard-skeleton" />
                <span className="favorite-exam-shimmer__text dashboard-skeleton" />
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}

const MasterExamSection = ({ title, exams = [], emptyMessage, onOpen }) => (
  <Row className="g-3 dashboard-states">
    <Col md={12} xl={12}>
      <div className="d-flex align-items-center myexams-qb-header border-bottom-0">
        <div className="myexams-qb-left">
          <span className="myexams-qb-title fw-semibold blackText">{title}</span>
        </div>
        <div className="myexams-qb-divider" aria-hidden="true" />
      </div>
    </Col>
    {exams.length ? (
      <div className="enroll-Row">
        {exams.map((exam) => (
          <div key={exam.id}>
            <SliderCard item={exam} onClick={() => onOpen(exam)} />
          </div>
        ))}
      </div>
    ) : <p className="choose-state__status">{emptyMessage}</p>}
  </Row>
);

const ExamCategorySection = ({ categories = [] }) => (
  <Row className="g-3 dashboard-states mt-0">
    <Col md={12} xl={12}>
      <div className="d-flex align-items-center myexams-qb-header border-bottom-0">
        <div className="myexams-qb-left">
          <span className="myexams-qb-title fw-semibold blackText">Exam Categories</span>
        </div>
        <div className="myexams-qb-divider" aria-hidden="true" />
      </div>
    </Col>
    {categories.length ? categories.map((category) => (
      <div className="col-md-6" key={category.category_id}>
        <div className="exam-card d-flex align-items-center position-relative exam-border">
          <div className="examContent d-flex align-items-center justify-content-between w-100 position-relative">
            <div className="d-flex align-items-center gap-3">
              <img src={category.icon_url || category.image_url || examFallbackImage} alt="" className="exam-img" />
              <div>
                <h6 className="exam-title mb-0 fw-semibold">{category.name || "Exam category"}</h6>
                <p className="exam-subtitle mb-0">
                  <span className="fw-medium exam-count">{Number(category.exam_count || 0)} Exam{Number(category.exam_count || 0) === 1 ? "" : "s"}</span>
                  <span className="fw-normal exam-selected ms-1">({Number(category.favorite_count || 0)} favorites)</span>
                </p>
              </div>
            </div>
            <span className="chevron-btn"><i className="bi bi-chevron-right" /></span>
          </div>
        </div>
      </div>
    )) : <p className="choose-state__status">No exam categories available.</p>}
  </Row>
);

const MasterExamList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const selectedState = location.state?.selectedState || {};
  const stateId = Number(location.state?.state_id || selectedState?.state_id || user?.state_id || user?.stateId || 0);
  const favouriteStateId = Number(location.state?.favourite_state_id || user?.favourite_state_id || user?.favorite_state_id || 0);
  const favouriteExamId = Number(location.state?.favourite_exam_id || user?.favourite_exam_id || user?.favorite_exam_id || 0);
  const { data = {}, isLoading, isError, error } = useMasterExamCategories({
    stateId,
    favouriteStateId,
    favouriteExamId,
  });
  const subscribedExams = (Array.isArray(data?.subscribed_exams) ? data.subscribed_exams : []).map(mapMasterExam);
  const popularExams = (Array.isArray(data?.popular_exams) ? data.popular_exams : []).map(mapMasterExam);
  const examCategories = Array.isArray(data?.categories_list) ? data.categories_list : [];
  const loadError = isError
    ? error?.response?.data?.message || error?.message || "Unable to load master exams."
    : "";
  const openMasterExam = (exam) => navigate(EXAM_COURSE_ROUTES.plans, {
    state: { md_exam_id: Number(exam.id), selectedMasterExam: exam },
  });

  return (
    <>
      <HomeDashboardLayout showHeader={false} variant="exam-course-wallet-layout">
        <div className="qbl-page qbankList-page page-padding master-exam-list-page">
          <div className="start-quiz qbl-main instruction-main">
            <div className="hideProfile-page">
              <div className="categories-page-header mb-0">
                <div><button type="button" className="categories-back-button" onClick={() => navigate(-1)}><i className="bi bi-chevron-left" /></button></div>
                <div />
                <div><HeaderProfileSection /></div>
              </div>
            </div>
            <div className="rapid-fire-header ex-header">
              <h1 className="qb-title">Master Exam <span>List</span></h1>
            </div>
            <div className="innerContent dashboardExam p-0">
              <div className="battle myexams-block">
                {isLoading ? <MasterExamShimmer /> : null}
                {!isLoading && loadError ? <p className="choose-state__status choose-state__status--error">{loadError}</p> : null}
                {!isLoading && !loadError ? (
                  <>
                    <MasterExamSection title="Your Enrolled Exams" exams={subscribedExams} emptyMessage="No enrolled master exams available." onOpen={openMasterExam} />
                    <MasterExamSection title="Popular Exams" exams={popularExams} emptyMessage="No popular master exams available." onOpen={openMasterExam} />
                    <ExamCategorySection categories={examCategories} />
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <MyWalletSidebar withTopOffset={false} />
      </HomeDashboardLayout>
    </>
  );
};

export default MasterExamList;
